<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="PermissionRole"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("PermissionAddRole") }} </h6>
                      <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    >
                    
                    </div>
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("roleTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <!-- <select class="form-control" name="role_id" id="role_id" v-model="forms.role_id" >
                            <option  v-for="(a, index) of fetchRole" :value="a.role_id" :key="index">{{a.name}}</option>
                        </select> -->

                         <v-select
                          :options="fetchRole"
                          v-model="role"
                          label="name"
                          return-object
                          @search="asyncSearchRole"
                        ></v-select>

                        <div v-if="errors.role_id">
                          <div
                            v-for="error in errors.role_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("PermissionTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchPermission"
                          v-model="permission"
                          label="name"
                          return-object
                          @search="asyncSearchPermission"
                        ></v-select>

                        <!-- <select class="form-control" name="permission_id" id="permission_id" v-model="forms.permission_id" >
                            <option  v-for="(a, index) of fetchPermission" :value="a.permission_id" :key="index">{{a.name}}</option>
                        </select> -->

                        <div v-if="errors.permission_id">
                          <div
                            v-for="error in errors.permission_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("ReadTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_read" id="method_read" value="1" v-model="forms.method_read" >
                        <label class="form-check-label" for="method_read">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_read" id="method_read" value="0" v-model="forms.method_read">
                        <label class="form-check-label" for="method_read">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_read">
                          <div
                            v-for="error in errors.method_read"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("CreateTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_create" id="method_create" value="1" v-model="forms.method_create" >
                        <label class="form-check-label" for="method_create">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_create" id="method_create" value="0" v-model="forms.method_create">
                        <label class="form-check-label" for="method_create">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_create">
                          <div
                            v-for="error in errors.method_create"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("UpdateTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_update" id="method_update" value="1" v-model="forms.method_update" >
                        <label class="form-check-label" for="method_update">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_update" id="method_update" value="0" v-model="forms.method_update">
                        <label class="form-check-label" for="method_update">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_update">
                          <div
                            v-for="error in errors.method_update"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("UploadTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_upload" id="method_upload" value="1" v-model="forms.method_upload" >
                        <label class="form-check-label" for="method_upload">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_upload" id="method_upload" value="0" v-model="forms.method_upload">
                        <label class="form-check-label" for="method_upload">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_upload">
                          <div
                            v-for="error in errors.method_upload"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("DeleteTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_delete" id="method_delete" value="1" v-model="forms.method_delete" >
                        <label class="form-check-label" for="method_delete">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_delete" id="method_delete" value="0" v-model="forms.method_delete">
                        <label class="form-check-label" for="method_delete">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_delete">
                          <div
                            v-for="error in errors.method_delete"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Custom1</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom1" id="method_custom1" value="1" v-model="forms.method_custom1" >
                        <label class="form-check-label" for="method_custom1">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom1" id="method_custom1" value="0" v-model="forms.method_custom1">
                        <label class="form-check-label" for="method_custom1">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_custom1">
                          <div
                            v-for="error in errors.method_custom1"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Custom2</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom2" id="method_custom2" value="1" v-model="forms.method_custom2" >
                        <label class="form-check-label" for="method_custom2">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom2" id="method_custom2" value="0" v-model="forms.method_custom2">
                        <label class="form-check-label" for="method_custom2">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_custom2">
                          <div
                            v-for="error in errors.method_custom2"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Custom3</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom3" id="method_custom3" value="1" v-model="forms.method_custom3" >
                        <label class="form-check-label" for="method_custom3">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom3" id="method_custom3" value="0" v-model="forms.method_custom3">
                        <label class="form-check-label" for="method_custom3">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_custom3">
                          <div
                            v-for="error in errors.method_custom3"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Custom4</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom4" id="method_custom4" value="1" v-model="forms.method_custom4" >
                        <label class="form-check-label" for="method_custom4">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom4" id="method_custom4" value="0" v-model="forms.method_custom4">
                        <label class="form-check-label" for="method_custom4">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_custom4">
                          <div
                            v-for="error in errors.method_custom4"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Custom5</label>
                      </div>
                      <div class="col-lg-8">

                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom5" id="method_custom5" value="1" v-model="forms.method_custom5" >
                        <label class="form-check-label" for="method_custom5">
                          {{$t("YesTxt")}}
                        </label>
                        </div>


                        <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" name="method_custom5" id="method_custom5" value="0" v-model="forms.method_custom5">
                        <label class="form-check-label" for="method_custom5">
                          {{$t("NoTxt")}}
                        </label>
                        </div>

                        <div v-if="errors.method_custom5">
                          <div
                            v-for="error in errors.method_custom5"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                     <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "PermissionRoleAdd",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchRole:[],
      fetchPermission:[],
      userData: "",
      permission:[],
      role:[],
      forms: { name: "", usernmae: "" },
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.role_id = "";
      this.forms.permission_id = "";
      this.forms.method_create = "";
      this.forms.method_read = "";
      this.forms.method_update = "";
      this.forms.method_delete = "";
      this.forms.method_upload = "";
      this.forms.method_custom1 = "";
      this.forms.method_custom2 = "";
      this.forms.method_custom3 = "";
      this.forms.method_custom4 = "";
      this.forms.method_custom5 = "";  
      this.forms.permission=[];
      this.forms.role=[];
    },


    backForm() {
       window.location.href = "/rolpermis";
    },


    
    loadRole() {
      const baseURI = this.$settings.endPoint + "/role";
     
      return this.$http
        .get(
          baseURI
        )
        .then((response) => {
            this.fetchRole=response.data.datas.data;
        });
    },


    asyncSearchRole(ev){
      const baseURI = this.$settings.endPoint + "/role?name="+ev;
     
      return this.$http
        .get(
          baseURI
        )
        .then((response) => {
           this.fetchRole=response.data.datas.data;
        });
    },


     
    loadPermission() {
      const baseURI = this.$settings.endPoint + "/permission";
     
      return this.$http
        .get(
          baseURI
        )
        .then((response) => {
            this.fetchPermission=response.data.datas.data;
        });
    },


    asyncSearchPermission(ev){
      const baseURI = this.$settings.endPoint + "/permission?name="+ev;
     
      return this.$http
        .get(
          baseURI
        )
        .then((response) => {
            this.fetchPermission=response.data.datas.data;
        });
    },


    submitData() {
      this.fade(true);

          this.forms.permission_id=this.permission.permission_id;
          this.forms.role_id=this.role.role_id;

          const baseURI  =  this.$settings.endPoint+"permission-role/create";
          this.$http.post(baseURI,this.forms).then((response) => {
              this.loading();
              if(response.data.status === 200) {
              //this.resetForm();
                  this.errors = [];
                  //console.log(response.data.datas.user_id);
                  var params = this.$onRandom(response.data.datas.permission_role_id);
                //   window.location.href = "/rolpermis/detail/" + params;
                    window.location.href = "/rolpermis/detail/" + params + "?status=200&msg=Successfully";
                  // this.success('Berhasil');
              }else{
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
              }
          }).catch(error => {
              this.loading();
              if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                    
                      this.error(this.errors.messages);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
              }
              //this.resetForm();
          });
    },

    fade(sType) {
      this.isLoading = sType;
    },


    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'PermissionRoleController'){
          rolePermision = permision;
        }
      });

      if(!rolePermision.method_create){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },




    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
      this.loadRole();
      this.loadPermission();
  },
};
</script>
<style scoped>
</style>